// Replace with your own Stripe public key
const stripePublicKey =
  "pk_test_51OJjHhBcWHNfRLxoTQtLnNbvROhuE3ow96XE7jO3SwRhxQypNaBohnCiVjoS3EEsKko7ltbfwm8aGrGiEis8oDMs00M9NIDz5R";

// Initialize Stripe.js with your public key
const stripe = Stripe(stripePublicKey);

// Create an instance of Elements
const elements = stripe.elements();
const cardElement = elements.create("card");

// Mount cardElement to the stripe-card-element div
cardElement.mount("#stripe-card-element");

// Handle real-time validation errors from the card Element
cardElement.addEventListener("change", (event) => {
  const displayError = document.getElementById("card-errors");
  if (event.error) {
    displayError.textContent = event.error.message;
  } else {
    displayError.textContent = "";
  }
});

// Handle form submission
const submitButton = document.getElementById("submit-button");
submitButton.addEventListener("click", async () => {

  const fullnameInput = document.getElementById("fullname");
  const fullname = fullnameInput.value;

  if (fullname==null || fullname == '') {
    Swal.fire('Please enter fullname!', '', 'error');
    return;
  }
  const amountInput = document.getElementById("amount");
  const amount = parseFloat(amountInput.value);

  if (isNaN(amount) || amount <= 0) {
    Swal.fire('Please enter a valid amount!', '', 'error');
    return;
  }
  const { token, error } = await stripe.createToken(cardElement);

  if (error) {
    // Display error to the user
    const displayError = document.getElementById("card-errors");
    displayError.textContent = error.message;
  } else {
    // Send token and amount to your server for payment processing
    console.log(token, amount);
    // Replace 'your-server-endpoint' with your actual server endpoint
    fetch("https://test.platerate.guru/charge", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: token.id,
        amount: parseFloat(amount) * 100,
        emailamount: parseFloat(amount) ,
        fullname: fullname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle server response (success or failure)
        console.log(data);
        if (data.success) {
          
          Swal.fire('Payment successful!', '', 'success');
        } else {
          Swal.fire("Oops", "Payment failed!", "error");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});
